/// <reference path="../factories/httphelper.factory.ts" />

module App.Services {
    export interface IPipelineDataService {
        getPipelineSteps(): ng.IPromise<string[]>
    }

    export class PipelineDataService implements IPipelineDataService {
        static serviceId = "pipelineDataService";

        static $inject = [
            '$q',
            '$http',
            HttpHelper.factoryId
        ];

        constructor(private $q: ng.IQService,
                    private $http: ng.IHttpService,
                    private httpHelperFactory: IHttpHelper) {
            
        }

        menuItems: string[];

        getPipelineSteps = (): ng.IPromise<string[]> => {
            var deferred = this.$q.defer<string[]>();
            
            var method = 'POST';
            this.httpHelperFactory.makeCall<string[]>(Constants.websiteUrlCalls.getSteps, method, { Pipeline: App.Variables.configuratorType }, { 'AmegaPlannerFranchise': App.Variables.websiteId })
                .then((result) => {
                    deferred.resolve(result);
                })
                .catch((err) => {
                    deferred.reject(err.message);
                });

            return deferred.promise;
        }
    }
    
    app.service(PipelineDataService.serviceId, PipelineDataService);
}